<!-- 兑换记录 -->
<template>
  <div class="exchange-container">
    <top></top>
    <van-list v-if="list.length" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList" class="log-wrapper">
      <div class="log-item" v-for="item in list" :key="item.id" @click="toDetail(item)">
        <div class="left">
          <p>{{userInfo.app.credit_alias}}兑换 <span>{{item.product.name}}</span></p>
          <span>{{item.created | timeParse}}</span>
        </div>
        <div class="right">{{item.status | statusFilter}}</div>
      </div>
    </van-list>
    <div v-else class="blank-content">
      <p class="blank-title">没找到兑换记录</p>
      <p class="blank-desc">亲爱的用户您没有任何兑换记录</p>
      <button @click="toIndex" class="blank-btn">去主页看看</button>
    </div>
  </div>
</template>

<script>
import top from '@/components/top'
import Vue from 'vue'
import { List } from 'vant'
import { mapGetters } from 'vuex'
Vue.use(List)

export default {
  name: 'ExchangeLog',
  components: { top },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      next: '/order/?limit=10'
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  filters: {
    timeParse(time) {
      const dateArr = time.split('T')
      const timeArr = dateArr[1].split('.')
      return dateArr[0] + ' ' + timeArr[0]
    },
    statusFilter(status) {
      const statusMap = {
        0: '待发货',
        1: '已发货',
        2: '已取消'
      }
      return statusMap[status]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      var that = this
      this.axios.get(this.next).then(function(res) {
        that.list = that.list.concat(res.data.results)
        that.loading = false
        if (res.data.next) {
          that.next = res.data.next
        } else {
          that.finished = true
        }
      }).catch(function(error) {
        console.log(error)
      })
    },

    toDetail(item) {
      this.$router.push({ path: '/user/exchange/detail', query: { orderId: item.id }})
    },

    /**
     * 去首页
     */
    toIndex() {
      this.$router.replace({ path: '/' })
    }
  }
}
</script>

<style lang="scss" scoped>
.log-wrapper{
  margin-top: 60px;
  .log-item{
    width: 335px;
    height: 70px;
    padding: 0 15px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto 1px;
    .left{
      height: 50px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      p{
        width: 210px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        color: #4a4a4a;
        font-size: 14px;
        font-weight: 400;
        span{
          color: #f5a623;
          font-size: 14px;
          font-weight: 600;
        }
      }
      span{
        color: #aaaaaa;
        font-size: 12px;
        font-weight: 400;
      }
    }
    .right{
      color: #747474;
      font-size: 14px;
      font-weight: 400;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/exchange/log.vue